/**
 * Accessibility fix for the Judge.me review carousel.
 *
 * Judge.me injects its own markup asynchronously (outside theme control), and the
 * carousel item links (`a.jdgm-carousel-item__product`) ship with no discernible
 * text for screen readers / accessibility trees — just an image with no alt/label.
 *
 * This watches for the carousel and gives each product link an aria-label built
 * from the product image's alt text (or a sensible fallback), without touching
 * Judge.me's own files.
 */
(function () {
  var FALLBACK_LABEL = 'Zum Produkt';

  function labelCarouselLink(link) {
    if (!link || link.hasAttribute('aria-label')) return;

    var img = link.querySelector('img');
    var text =
      (img && (img.getAttribute('alt') || img.getAttribute('title'))) ||
      link.getAttribute('title') ||
      FALLBACK_LABEL;

    link.setAttribute('aria-label', text.trim());
  }

  function labelExistingLinks(root) {
    root
      .querySelectorAll('a.jdgm-carousel-item__product')
      .forEach(labelCarouselLink);
  }

  // Judge.me may already be present on load...
  labelExistingLinks(document);

  // ...but usually renders after an async app-embed script runs, so observe for it.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;

        if (node.matches && node.matches('a.jdgm-carousel-item__product')) {
          labelCarouselLink(node);
        } else if (node.querySelectorAll) {
          labelExistingLinks(node);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
